import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ServiceRequestActionContainerModel } from '../../../../../../models/aggregates/erp/rma';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ServiceRequestActionService extends BaseApiTemplateService<ServiceRequestActionContainerModel> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/request-actions/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/request-actions/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/request-actions/backoffice-ep';
    this.httpClient = http;
  }
}
